import { render, staticRenderFns } from "./Servicos.vue?vue&type=template&id=5eca6dfa&scoped=true&"
import script from "./Servicos.vue?vue&type=script&lang=js&"
export * from "./Servicos.vue?vue&type=script&lang=js&"
import style0 from "./Servicos.vue?vue&type=style&index=0&id=5eca6dfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eca6dfa",
  null
  
)

export default component.exports